// extracted by mini-css-extract-plugin
export default {"linkyButton":"LinkyButton_linkyButton__EMwjB","active":"LinkyButton_active__1sv4d"};